import { produce } from "immer";

export default produce(
  (draft, action) => {
    const { type, payload } = action;

    switch (type) {
      case "@GROUP/GetList:FULFILLED":
        draft.list = payload;
        return;

      default: {
        return draft;
      }
    }
  },
  { list: [], isFetching: false }
);
